var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckRulesOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 8,
    fill: "#011235",
    fillOpacity: 0.05
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.19526 7.52861C4.45561 7.26826 4.87772 7.26826 5.13807 7.52861L7.10457 9.4951L11.0711 5.52861C11.3314 5.26826 11.7535 5.26826 12.0139 5.52861C12.2742 5.78896 12.2742 6.21107 12.0139 6.47141L7.57597 10.9093C7.31562 11.1697 6.89351 11.1697 6.63316 10.9093L4.19526 8.47141C3.93491 8.21106 3.93491 7.78895 4.19526 7.52861Z",
    fill: "#011235",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckRulesOff);
export default __webpack_public_path__ + "static/media/check-rules-off.63191e0ace6a2e6ac72b2de77846a421.svg";
export { ForwardRef as ReactComponent };